<div class="checkedlistbox">
    <h4 *ngIf="titleVisible" class="paneltitle">{{ title }}</h4>
    <div
        (click)="activeItem(item)"
        *ngFor="let item of items"
        [ngClass]="isVerticalOrientation ? 'verticalitems' : 'horizontalitems'"
    >
        <ng-content></ng-content>
    </div>
</div>
